import { FamilyRules, Reward } from '../types/family';

// Prilagodljiva predloga za nove družine. Nevtralne vrednosti, ki jih mora skrbnik pregledati.
// Ne vsebuje članov, zgodovine, dogodkov, koledarjev ali živali nobene obstoječe družine.

export const neutralRules: FamilyRules = {
  readingMinutes: 20,
  basicThresholdPct: 75,
  allowanceAmount: 0,
  currency: '€',
  payoutDay: 'nedelja',
  payoutTime: '19.00',
  sportMinutes: 45,
  sportPerWeekChild: 3,
  sportPerWeekChildWithSchoolPE: 2,
  sportPerWeekAdult: 3,
  houseCategoryValue: 20,
  roomBonus: 1,
  roomBonusWeeklyMax: 6,
  extraMinutesStep: 15,
  extraMinutesBonus: 2,
  extraDailyMax: 4,
  lessonDayBonus: 5,
  evening: { schoolNightRoom: '21.00', weekendRoom: '22.00', weekendSleep: '22.30', devicesPlace: 'skupno polnilno mesto' },
  reminders: { dailySummary: '18.00', eveningMinutesBefore: 15 },
  visibility: { calendarAll: true, personalParentsOnly: true },
};

export const neutralHouseCategories = ['Kuhinja', 'Kopalnica', 'Sesanje'];

export const neutralRewards: Omit<Reward, 'id'>[] = [
  { title: 'Izbira filma', cost: 30 },
  { title: 'Dodatnih 30 minut igranja', cost: 40 },
];

export const memberPalette = ['#2F5D9A', '#7B4FB0', '#C2501F', '#2E7D4F', '#B23A6B', '#8A5A00', '#1F6F80', '#5B6B2E'];

export const quickTaskPresets = [
  'Priprava torbe za jutri',
  'Pospravljanje za seboj',
  'Prevoz',
  'Nakup',
  'Priprava obroka',
  'Administrativni opravek',
];
